import { createUseMutationHook } from './createUseMutationHook';

export const useCreateAccountInTripForYandexLogin = createUseMutationHook(
    'create_account_in_trip_for_yandex_login',
    () => [
        ['employee_list'],
    ],
);
